/*
 *  Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
 *  is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
 *  and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
 *
 *  You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
 *  in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
 *  forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
 *  explicitly covering such access.
 *
 *  The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
 *  which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
 *
 *  ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
 *  CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
 *  INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
 *  OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
 *  THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.
 *
 */

import React, { CSSProperties, useEffect, useState, memo } from 'react'
import { DatePicker, Form, Modal, TimePicker } from 'antd'
import { getCameraGroupSettingByID } from '../../api/setting'
import { GroupCameraStatus } from '../../constants/setting'

const styleLabel = (labelText: string, style: CSSProperties={}) => {
  return (
    <span style={{fontSize: '16px',fontFamily: 'SanomatGrabApp', color: '#000000',...style}}>{labelText}</span>
  )
}

const UploadModal = props => {
  const { title, visible, okText, onChange ,initialValues,validateInfo,...modalProps} = props
  const [uploadStatus, setUploadStatus] = useState(false)
  const [uploadForm] = Form.useForm()
  useEffect(() =>{
    const {groupID} = validateInfo || {}
    validateUpload(groupID)
    if(!visible) return
    uploadForm.resetFields()
    // uploadForm.setFieldsValue({uploadDate:null,uploadTime: null,...initialValues})
  },[visible])
  const validateUpload = async (groupID) => {
    if(groupID === undefined || groupID === 0) {
      setUploadStatus(true)
    }else{
      const {status} = await getCameraGroupSettingByID(groupID)
      setUploadStatus(status === GroupCameraStatus.normal)
    }
  }
  const handleUploadModal = (type) => async () => {
    switch (type) {
      case 'cancel':
        onChange({ type: 'cancel', payload: null })
        break
      case 'ok':
        const values = await uploadForm.validateFields()
        const { uploadDate = [], uploadTime = [] } = values
        const [startDate, endDate] = uploadDate
        const [startTime, endTime] = uploadTime
        onChange({ type: 'ok', payload: { startDate, startTime, endDate, endTime } })
        break
      default:
        break
    }
  }
    const uploadDateConfig = {
      rules: [{ type: 'array' as const, required: true, message: 'Please select Date!' }],
    };
    const uploadTimeConfig = {
      rules: [
        { type: 'array' as const, required: true, message: 'Please select time!' }],
    };

    const UploadWaring = 'This is not allowed. Please make sure the 360 lite group has 4 cameras.'

    return (
          <Modal
            title={title}
            visible={visible}
            width={450}
            centered={true}
            onCancel={handleUploadModal('cancel')}
            onOk={handleUploadModal('ok')}
            okText={okText}
            okButtonProps={{disabled: !uploadStatus}}
            {...modalProps}
          >
            {
              uploadStatus
                ? (
                  <Form
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    labelAlign={'left'}
                    form={uploadForm}
                    initialValues={{ ...initialValues }}
                  >
                    <Form.Item label={styleLabel('Upload date')} name={'uploadDate'} {...uploadDateConfig}>
                      <DatePicker.RangePicker style={{ width: '100%' }} />
                    </Form.Item>
                    <Form.Item label={styleLabel('Upload time')} name={'uploadTime'} {...uploadTimeConfig}>
                      <TimePicker.RangePicker style={{ width: '100%' }} use12Hours format={'hh:mm A'} minuteStep={5} />
                    </Form.Item>
                  </Form>

                )
                : UploadWaring
            }

          </Modal>
    )
  }


export default memo(UploadModal)
